
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.503 0C3.37 0 0 3.365 0 7.498S3.37 15 7.503 15 15 11.631 15 7.498C15 3.365 11.636 0 7.503 0zm0 1.363a6.123 6.123 0 016.134 6.135 6.127 6.127 0 01-6.134 6.139 6.132 6.132 0 01-6.14-6.139 6.129 6.129 0 016.14-6.135zm-.01 2.717a.682.682 0 00-.675.695v2.043H4.775a.68.68 0 00-.542.224.683.683 0 00.542 1.14h2.043v2.043a.682.682 0 101.364 0V8.181h2.043a.682.682 0 100-1.364H8.181V4.775a.682.682 0 00-.69-.695z","fill":"#fff"}})])
          )
        }
      }
    